import {Component} from '@angular/core';
import {Location} from '@angular/common';
import {ActivationEnd, Router} from '@angular/router';
import {PageComponent} from './page.component';
import {MatIconRegistry} from '@angular/material/icon';
import {DomSanitizer} from '@angular/platform-browser';


@Component({
  selector: 'mp-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  public navigationOpened: boolean;
  public showBackButton: boolean;
  public isLightPage: boolean;

  private closeMenuCallback: any = _ => this.navigationOpened = false;

  public getCloseMenuCallback(): void {
    return this.closeMenuCallback.bind(this);
  }

  constructor(private location: Location, private router: Router, private matIconRegistry: MatIconRegistry, private domSanitzer: DomSanitizer) {
    router.events.subscribe(event => {
      if (!(event instanceof ActivationEnd)) {
        return;
      }

      const component = (router as any).rootContexts.contexts
        && (router as any).rootContexts.contexts.get('primary')
        && (router as any).rootContexts.contexts.get('primary').outlet.component;

      if (!(component instanceof PageComponent)) {
        this.showBackButton = false;
        return;
      }

      this.showBackButton = component.canGoBack();
      this.isLightPage = component.isLightPage();
    });

    this.registerIcons();
  }

  private registerIcons(): void {
    this.matIconRegistry.addSvgIcon(
      'mp_menu',
      this.domSanitzer.bypassSecurityTrustResourceUrl('assets/icons/burger.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'mp_close',
      this.domSanitzer.bypassSecurityTrustResourceUrl('assets/icons/cancel.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'mp_back',
      this.domSanitzer.bypassSecurityTrustResourceUrl('assets/icons/arrow-left.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'mp_go',
      this.domSanitzer.bypassSecurityTrustResourceUrl('assets/icons/arrow-right.svg')
    );
  }

  public toggleNavigation(): void {
    this.navigationOpened = !this.navigationOpened;
  }

  public goBack(): void {
    this.location.back();
  }
}
